import { render, staticRenderFns } from "./userGuidePopovers.vue?vue&type=template&id=4af6beeb&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4af6beeb')) {
      api.createRecord('4af6beeb', component.options)
    } else {
      api.reload('4af6beeb', component.options)
    }
    module.hot.accept("./userGuidePopovers.vue?vue&type=template&id=4af6beeb&", function () {
      api.rerender('4af6beeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/userGuidePopovers.vue"
export default component.exports